<div class="app-shell">
  <app-header></app-header>
  <div class="shell-body">
    <app-sidebar></app-sidebar>
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
